import m from 'mithril'
import {
    Dialog,
} from 'components'
import {
    Setting,
    Model,
    Category,
    User,
    Module
} from 'app/models'
import EditDialog from './editModule'
import { backgroundColor } from 'echarts/lib/theme/dark'

export default class SettingPage {
    constructor() {
        this.modules = []
        User.getModules().then((_res) => {
            if (_res && _res.modules) {
                this.modules = _res.modules
            }
        })
    }

    view() {
        return [
            m(".px-2.py-4.position-relative.container",
                m(".row.w-100.m-0", [
                    m(".col-12.pb-3", [
                        m(".d-flex.align-items-center.px-2", [
                            m("span", {
                                style: {
                                    fontSize: "1.25rem",
                                    color: "#fff",
                                    fontWeight: "600",
                                    display: "block",
                                    flexGrow: 1
                                }
                            }, "功能設定"),
                            m("i.fas.fa-circle-info.ms-2", {
                                style: {
                                    fontSize: "1rem",
                                    color: "#6C5CE7",
                                    cursor: "pointer",
                                    padding: "5px",
                                    borderRadius: "50%",
                                },

                                onclick: (e) => {
                                    e.preventDefault();
                                    chrome.tabs.create({
                                        url: "https://robot.apeai.com.tw/ai-prompt/"
                                    });
                                }
                            })
                        ])
                    ]),
                    m(".col-12.text-center", [
                        m(".row.w-100.m-0", [
                            this.modules.map((_data) => {
                                return [
                                    m(".col-md-4.col-6.p-1", [
                                        m(".d-flex.justify-content-center.align-items-center.h-100.module-card.text-center.position-relative", {
                                            style: {
                                                color: "#fff",
                                                padding: "15px 5px",
                                                borderRadius: "12px",
                                                cursor: "pointer",
                                                border: "1px solid rgba(255, 255, 255, 0.1)",
                                                backgroundColor: "#333",
                                                boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
                                                transition: "all 0.3s ease"
                                            },
                                            onmouseover: (e) => {
                                                e.target.style.transform = "translateY(-2px)";
                                            },
                                            onmouseout: (e) => {
                                                e.target.style.transform = "translateY(0)";
                                            },
                                            onclick: (e) => {
                                                e.preventDefault()
                                                e.stopPropagation()
                                                Dialog.show(EditDialog, {
                                                    attrs: {
                                                        model: new Module(_data)
                                                    },
                                                    didHide: (returnValue) => {
                                                        if (returnValue) {
                                                            User.getModules().then((_res) => {
                                                                if (_res && _res.modules) {
                                                                    this.modules = _res.modules
                                                                }
                                                            })
                                                        }
                                                    }
                                                });
                                            }
                                        }, [
                                            m("span", {
                                                style: {
                                                    fontSize: "1rem",
                                                    fontWeight: "600"
                                                }
                                            }, _data.name),
                                        ]),
                                    ]),
                                ]


                            }),

                            m(".col-md-4.col-6.p-1", {
                                onclick: (e) => {
                                    e.preventDefault();
                                    Dialog.show(EditDialog, {
                                        attrs: {
                                            model: new Module()
                                        },
                                        didHide: (returnValue) => {
                                            if (returnValue) {
                                                User.getModules().then((_res) => {
                                                    if (_res && _res.modules) {
                                                        this.modules = _res.modules
                                                    }
                                                })
                                            }
                                        }
                                    });
                                }
                            }, [
                                m(".d-flex.justify-content-center.align-items-center.h-100.module-card.text-center", {
                                    style: {
                                        color: "#fff",
                                        padding: "15px 0px",
                                        borderRadius: "12px",
                                        cursor: "pointer",
                                        border: "1px dashed rgba(108, 92, 231, 0.5)",
                                        height: "100px",
                                        boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
                                        transition: "all 0.3s ease"
                                    },
                                    onmouseover: (e) => {
                                        e.target.style.transform = "translateY(-2px)";
                                    },
                                    onmouseout: (e) => {
                                        e.target.style.transform = "translateY(0)";
                                    }
                                }, [
                                    m("span", {
                                        style: {
                                            fontSize: "1.5rem",
                                            color: "#6C5CE7",
                                            fontWeight: "300"
                                        }
                                    }, "+")
                                ]),
                            ])

                        ])
                    ]),

                ])
            ),
            m(Dialog),
        ]
    }
}